module.exports = __webpack_public_path__ + "static/media/detailed.3906d2b7.png";